// /portal szegmens layout-ja — a PARTNER-felület gyökere: auth-guard + partner app-shell + <Outlet/>.
//
// A FELÜLET-VÁLASZTÁS a `/session` `type`-jából dől el (egy belépő-felület, egy cím — user-döntés):
// a route-guard (`requirePartnerSurface`) belsős tokennel MÁR A RENDERELÉS ELŐTT visszairányít a belső
// felületre; a `PortalShell` `useEffect`-je a FUTÁS KÖZBENI típus-váltást fogja. A jogosultsági FAL a szerveren van (a BFF
// partner-végpontjai `@AllowPartner()`-rel nyílnak, és portál-szerep nélkül 403-at adnak) — ez itt IRÁNYÍTÁS,
// nem védelem.
import { Outlet, createFileRoute } from '@tanstack/react-router';

import { PortalShell } from '@/components/portal/portal-shell';
import { requirePartnerSurface } from '@/lib/require-permission';

export const Route = createFileRoute('/portal')({
  beforeLoad: () => requirePartnerSurface(),
  component: PortalLayout,
});

function PortalLayout(): JSX.Element {
  return (
    <PortalShell>
      <Outlet />
    </PortalShell>
  );
}
